import React, { PureComponent } from "react";
import { injectIntl, defineMessages } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, change, reset } from "redux-form";

import { Message, List } from "semantic-ui-react";
import { ModalTemplate, Loading, Button as Btn, ReduxFormMaterialTextField } from "components";

import * as common from "libs/commonFunc";
import * as eduTemplateActions from "modules/eduTemplate";
import "./EduTemplateAddEdit.css";
import { bind } from "classnames/bind";

class EduTemplateAddEdit extends PureComponent {
  state = {
    loading: false,
    videoList: [],
    isDisabled: true,
  };

  componentDidUpdate(prevProps, prevState) {
    const { formStore, change } = this.props;
    if (this.state.videoList.length !== prevState.videoList.length) {
      change("fileName", "");
      change("filePath", "");
      this.checkValid();
    }

    if (formStore && !formStore.syncErrors) {
      this.checkValid();
    }
  }

  // 영상 추가 이벤트
  onAddVideo = () => {
    const { formStore } = this.props;
    const { updateState } = this;
    if (!formStore || !formStore.values) return;

    const { fileName, filePath } = formStore.values;
    if (fileName && filePath) {
      const fileList = [...this.state.videoList];
      // http://vod.cdn.hunet.co.kr/M_b2b/etc/20190528/HLSC26884/51_02.mp4

      var video = document.createElement("video");
      video.src = filePath;
      video.addEventListener("loadedmetadata", function () {
        if (fileList.length < 6) {
          fileList.push({
            fileName: fileName,
            filePath: filePath,
            runningTime: parseInt(video.duration),
          });
        }

        updateState(fileList);
      });
    }
  };

  // 영상 목록 업데이트
  updateState = (fileList) => {
    this.setState({
      videoList: fileList,
    });
  };

  // 유효성 검사
  checkValid = () => {
    const { formStore } = this.props;

    let disable = true;
    if (formStore && formStore.values && formStore.values.attachName && this.state.videoList.length > 0) {
      disable = false;
    }

    this.setState({
      isDisabled: disable,
    });
  };

  // 교육 템플릿 등록 이벤트
  onAddEduTemplate = async () => {
    const { EduTemplateActions, dataInfo, formStore, toggleModal } = this.props;
    const { isDisabled, videoList } = this.state;

    this.checkValid();

    if (!isDisabled) {
      try {
        this.setState({ loading: true });

        const params = {
          attachName: formStore && formStore.values && formStore.values.attachName,
          fileInfo: JSON.stringify(videoList),
        };

        await EduTemplateActions.addEduTemplate(params);
        this.setState({ loading: false });
        toggleModal();
      } catch (error) {
        console.log("onAddEduTemplate", error);
      }
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { dataInfo, toggleModal, config } = this.props;
    const { loading, videoList, isDisabled } = this.state;
    const { onAddVideo, onAddEduTemplate } = this;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={"modal-admin modal-eduTemplate-add common-content"}
        closeIcon
        onToggleModal={toggleModal}
        visible
        header={<div>{defineMessages(formatMessage({ id: "EduTemplate_9", defaultMessage: "교육 템플릿 등록" }))}</div>}
        buttons={
          <div className={"inline-block"}>
            <Btn buttonColor="#bbbbbb" onClick={toggleModal}>
              {defineMessages(formatMessage({ id: "ModalEdu_1", defaultMessage: "취 소" }))}
            </Btn>
            <Btn className={"brand-button"} loading={loading} disabled={loading || isDisabled} onClick={onAddEduTemplate}>
              {defineMessages(formatMessage({ id: "ModalEdu_6", defaultMessage: "등 록" }))}
            </Btn>
          </div>
        }
      >
        <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_1", defaultMessage: "컨텐츠명" }))}</span>
        <ReduxFormMaterialTextField
          required
          fullWidth
          name="attachName"
          className={"input-area input-text-indent"}
          checkType={101}
          validate={["required"]}
          // error={!!this.warnAttachCompress}
          // errorText={this.warnAttachCompress}
          // onChange={onChangeAttachCompress}
        />

        <div className="video-file-box">
          <div className="video-item">
            <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_4", defaultMessage: "영상명" }))}</span>
            <ReduxFormMaterialTextField
              required
              fullWidth
              name="fileName"
              className={"input-area input-text-indent"}
              checkType={101}
              // validate={["required"]}
              // error={!!this.warnAttachCompress}
              // errorText={this.warnAttachCompress}
              // onChange={onChangeAttachCompress}
            />
          </div>
          <div className="video-item">
            <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_11", defaultMessage: "영상 URL" }))}</span>
            <ReduxFormMaterialTextField
              required
              fullWidth
              name="filePath"
              className={"input-area input-text-indent"}
              checkType={101}
              // validate={["required"]}
              // error={!!this.warnAttachCompress}
              // errorText={this.warnAttachCompress}
              // onChange={onChangeAttachCompress}
            />
          </div>
          <Btn className="video-add-btn" onClick={onAddVideo}>
            {defineMessages(formatMessage({ id: "EduTemplate_13", defaultMessage: "추가" }))}
          </Btn>
        </div>
        <span className="materialTextField-title">{defineMessages(formatMessage({ id: "EduTemplate_12", defaultMessage: "추가한 영상 목록" }))}</span>
        <div className="video-list-box">
          <div className="video-list">
            {videoList.length > 0 &&
              videoList.map((video, index) => {
                return (
                  <div key={index} className="video-list-item">
                    <div>{video.fileName}</div>
                    <div className="ellipsis" title={video.filePath}>
                      {video.filePath}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </ModalTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  formStore: state.form["formEduTemplateAddEdit"],
});

const mapDispatchToProps = (dispatch) => ({
  EduTemplateActions: bindActionCreators(eduTemplateActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "formEduTemplateAddEdit",
    enableReinitialize: true,
    touchOnChange: true,
  })(injectIntl(EduTemplateAddEdit))
);



// WEBPACK FOOTER //
// ./src/script/components/eduTemplate/EduTemplateAddEdit.js